export default __webpack_public_path__ + "static/media/cenaidja-color.e5baf45a.svg";